import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';

export function companyExistsAsyncValidator(companies: any[]): (control: AbstractControl) => Observable<ValidationErrors | null> {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const enteredName = (control.value || '').trim().toLowerCase();
    if (!enteredName) return of(null);

    const exists = companies.some(
      (company: any) => company.companyName.toLowerCase() === enteredName
    );

    return of(
      exists
        ? { companyExists: true, errorMessage: 'This company name already exists. Please enter a unique name.'  }
        : null
    );
    //here return true if exist and set msg else null like this   return { emailExists: true, errorMessage: erroMsgText };

  };
}
